import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { metricKeys } from '@pulse/metrics';
import { RT_ON_TRENDS_REFRESH_INTERVAL, DATE_SHORTCUTS } from '@utils/constants';
import { updateInterval } from '@store/common/actions';
import { calcShortcutInterval } from '@utils';
import { RT_ON_TRENDS_EXCLUDE_LIST } from '@utils/metrics';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';
import { selectedMetricChart, setMetrics } from '@store/metricsChartContainer/actions';
import { selectedMetricSelector, metricSelector } from '@store/metricsChartContainer/selectors';
import { setDataType } from '@store/viewerSessions/actions';
import { clearMetricFilter } from '@store/trends/base/actions';
import { checkIfBrowserTabIsVisible } from '@src/hooks/useBrowserTabVisibility';

// TODO: a saga action could do these changes while setting the interval to 15m
function useSetupLiveMode({ autoRefresh }) {
  const dispatch = useDispatch();
  const liveModeSelected = useSelector(realTimeModeOnTrendsSelector);
  const selectedMetric = useSelector(selectedMetricSelector);
  const metricsList = useSelector(metricSelector);

  // apply live mode state restrictions
  useEffect(() => {
    if (liveModeSelected) {
      dispatch(setDataType('dimension', 'trends'));

      // filter metrics
      const updatedList = metricsList.filter(
        (metric) => !RT_ON_TRENDS_EXCLUDE_LIST.includes(metric),
      );
      if (!updatedList.length) {
        updatedList.push(metricKeys.Attempts);
      }
      dispatch(setMetrics(updatedList));
      if (!updatedList.includes(selectedMetric)) {
        dispatch(selectedMetricChart(updatedList[0]));
      }
    }
    // disable metric filter
    dispatch(clearMetricFilter());
  }, [liveModeSelected]);

  // updating the interval will trigger metrics api calls
  const refreshHandler = () => {
    // refresh trends only if the browser tab is active/in-focus
    if (checkIfBrowserTabIsVisible()) {
      const [from, to] = calcShortcutInterval(DATE_SHORTCUTS.last15Mins);
      dispatch(updateInterval(from.format(), to.format(), DATE_SHORTCUTS.last15Mins, 'trends'));
    }
  };

  // set interval for refresh
  useEffect(() => {
    let interval: any = null;

    if (liveModeSelected && autoRefresh) {
      // scheduled refresh
      interval = setInterval(() => {
        refreshHandler();
      }, RT_ON_TRENDS_REFRESH_INTERVAL);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [liveModeSelected, autoRefresh]);

  return { refreshHandler };
}

export default useSetupLiveMode;
